
import { Options, setup, Vue } from "vue-class-component";
import { useStore } from "vuex";
import { key } from "@/store";
import { useMeta } from "vue-meta";

import { library } from "@fortawesome/fontawesome-svg-core";
import { faCalculator } from "@fortawesome/free-solid-svg-icons";

library.add( faCalculator );

import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
import Loader from "../components/Loader.vue";
import SearchNew from "../components/Home_v2/SearchNew.vue";
import YellowCircles from "../components/Home_v2/YellowCircles.vue";
import CustomerQuotes from "../components/Home_v2/CustomerQuotes.vue";
import HomeFAQ from "@/components/Home_v2/HomeFAQ.vue";
import HomeContact from "@/components/Home_v2/HomeContact.vue";
import RegionPrices from "@/components/Home_v2/RegionPrices.vue";
import Stats from "@/components/Home_v2/Stats.vue";
import TopGM from "@/components/Home_v2/TopGM.vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

@Options( {
  components : {
    HomeContact,
    Header,
    Footer,
    Loader,
    SearchNew,
    YellowCircles,
    CustomerQuotes,
    HomeFAQ,
    Stats,
    RegionPrices,
    TopGM,
    FontAwesomeIcon
  }
} )
export default class extends Vue
{
  store   = useStore( key );
  window  = window;

  meta = setup( () => useMeta( {
    title       : [{
      content : "Garde meuble et self stockage dans toutes les villes de France",
      vmid    : "title",
      name    : "title"
    }],
    description : {
      content : "Location box de stockage et garde meuble sécurisé près de chez vous. Une offre de plus de 10 000 annonces de box à louer pour particulier et pro à tous les prix.",
      vmid    : "description",
      name    : "description"
    }
  } ) );

  mounted()
  {
    let headers = new Headers();

    fetch( this.store.state.apiVue + "home", {
      method  : "GET",
      headers : headers,
      cache   : "no-cache"
    } ).then( ( res ) => {
      return res.json();
    } ).then( ( json ) => {
      if( typeof json.error !== "undefined" )
      {
        // this.error = "Une erreur est survenue lors du chargement de la page (Error " + json.errcode + ")";
        console.error( json.error );
      } else
      {
        this.store.state.home_data = json.data;

        // Update ratings
        this.store.state.json_ld.aggregateRating.ratingCount = json.data.counter.avis;

        setTimeout( () => {
          this.store.state.loading = false;

          // Remove div#preload from DOM
          let preload = document.getElementById( "preload" );
          if( preload )
          {
            window.scrollTo( { top : 0 } );
            preload.remove();
          }
        }, this.store.state.delay );
      }
    } ).catch( error => {
      this.store.state.loading = false;
      console.error( error );
    } );
  }
}
